import { CircleDashed, CircleDot } from "lucide-react";

import { Button } from "components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "components/ui/tooltip";

export function ToggleProximityRingsButton({ isShowing = false, onToggle }) {
  const label = isShowing ? "Hide proximity rings" : "Show proximity rings";

  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <Button
            variant={isShowing ? "secondary" : "outline"}
            size="icon"
            aria-label={label}
            onClick={onToggle}
          >
            {isShowing ? (
              <CircleDot data-icon="inline-start" />
            ) : (
              <CircleDashed data-icon="inline-start" />
            )}
          </Button>
        }
      />
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  );
}
